import { BARE_DOMAIN_REGEXP, SAFE_HREF_REGEXP } from "./urlPatterns";

// Mirrors WHATWG URL parsing so `\tjava\nscript:` is caught without corrupting spaces in valid URLs.
const stripControlChars = (value: string) =>
  // eslint-disable-next-line no-control-regex -- matching control chars is the point
  value.replace(/^[\x00-\x20]+|[\x00-\x20]+$/g, "").replace(/[\t\n\r]/g, "");

export const sanitizeExternalUrl = (url: string | null | undefined): string => {
  if (!url) {
    return "";
  }

  const normalized = stripControlChars(url);

  if (SAFE_HREF_REGEXP.test(normalized)) {
    return normalized;
  }

  if (BARE_DOMAIN_REGEXP.test(normalized)) {
    return `https://${normalized}`;
  }

  return "";
};
